import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { useGetUserByEmail } from "@src/appV2/User/api/useGetUserByEmail";
import constate from "constate";
import { useCallback } from "react";

const FIVE_MINUTES = 1000 * 60 * 5;

interface UseKnockTokenOptions {
  userId: string | undefined;
}

function useKnockToken({ userId }: UseKnockTokenOptions) {
  const {
    data: user,
    refetch: refetchUser,
    isLoading,
  } = useGetUserByEmail({
    enabled: isDefined(userId),
    staleTime: FIVE_MINUTES,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleKnockTokenExpiring = useCallback(async () => {
    try {
      const { data } = await refetchUser();
      return data?.knockToken;
    } catch (error) {
      logError(APP_V2_APP_EVENTS.KNOCK_TOKEN_REFRESH_FAILED, { error });
      return undefined;
    }
  }, [refetchUser]);

  return {
    knockToken: user?.knockToken,
    isLoading,
    handleKnockTokenExpiring,
  };
}

export const [KnockTokenProvider, useKnockTokenContext] = constate(useKnockToken);
